module.exports = __webpack_public_path__ + "c7be3abf96feefbca4c71bfa6eae43c2.png";